// extracted by mini-css-extract-plugin
module.exports = {"content_title":"contactFormConfirmContent_content_title__26mz_","content":"contactFormConfirmContent_content__3V0YY","content_body":"contactFormConfirmContent_content_body__88yHB"};